import { render } from "./GoalAndBid.vue?vue&type=template&id=c5b80fe6"
import script from "./GoalAndBid.vue?vue&type=script&lang=js"
export * from "./GoalAndBid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__